import request from './axios';

export interface Film {
  filmID: string;
  filmOrgID: string;
  filmName: string;
  filmSynopsis?: string;
  filmType?: string;
  filmProjectType?: '分场项目' | '预算项目';
  filmTheme?: string[];
  filmDirector?: string;
  filmScreenwriter?: string;
  filmAssistantDirector?: string;
  filmProducer?: string;
  filmStartDate?: string;
  filmFinishDate?: string;
  filmStartShootingDate?: string;
  filmFinishShootingDate?: string;
  filmPoster?: string;
  filmStatus?: string;
  filmOwnerID?: string;
  filmAssigneeID?: string;
  filmCreatorID?: string;
  filmCreateTime?: string;
  filmUpdateTime?: string;
}

export interface GetFilmsParams {
  filmName?: string;
  filmOrgID?: string;
  filmType?: string;
  filmProjectType?: '分场项目' | '预算项目';
  filmTheme?: string[];
  filmStatus?: string;
  filmOwnerID?: string;
  filmAssigneeID?: string;
  /** 逗号分隔的影片ID，与后端 QueryFilmDto.filmIDs 一致 */
  filmIDs?: string;
}

const FILM_LIST_TIMEOUT_MS = 30000;

// 获取所有影片（列表/按 owner 筛选等可能较慢，长于默认 10s）
export const getFilms = (params?: GetFilmsParams, requestOpts?: { timeout?: number }) => {
  return request.get<Film[]>('/api/films', {
    params,
    timeout: requestOpts?.timeout ?? FILM_LIST_TIMEOUT_MS,
  });
};

// 获取单个影片
export const getFilmById = (filmId: string) => {
  return request.get<Film>(`/api/films/${filmId}`, { timeout: FILM_LIST_TIMEOUT_MS });
};

/** 按影片ID列表批量查询（权限驱动列表用） */
export const getFilmsByIds = (filmIDs: string[]) => {
  if (filmIDs.length === 0) {
    return Promise.resolve({ data: [] as Film[] });
  }
  return request.get<Film[]>('/api/films', {
    params: { filmIDs: filmIDs.join(',') },
    timeout: FILM_LIST_TIMEOUT_MS,
  });
};

// 创建影片（JSON格式）
export const createFilm = (data: Partial<Film>) => {
  return request({
    url: '/api/films',
    method: 'post',
    data: data
  });
};

// 创建影片（文件上传格式）
export const createFilmWithUpload = (formData: FormData) => {
  return request({
    url: '/api/films/upload',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// 更新影片
export const updateFilm = (id: string, data: Partial<Film>) => {
  return request({
    url: `/api/films/${id}`,
    method: 'patch',
    data: data
  });
};

// 删除影片
export const deleteFilm = (id: string) => {
  return request({
    url: `/api/films/${id}`,
    method: 'delete'
  });
};

// 获取影片的预算列表
export const getFilmBudgets = (filmId: string) => {
  return request({
    url: `/api/films/${filmId}/budgets`,
    method: 'get'
  });
}; 